import React from 'react';

import PropTypes from 'prop-types';
import {
  MdCancel,
  MdCheckCircle,
  MdDeleteForever,
  MdHelp,
  MdMoreVert,
} from 'react-icons/md';
import { FormattedMessage } from 'react-intl';

import { rsvpCodes, rsvpKey } from '../../../../../constants';
import Button from '../../../../Button';
import Dropdown from '../../../../Dropdown';
import Menu from '../../../../Menu';
import styles from './RSVPActionsMenu.less';

const { Item: MenuItem } = Menu;

const RSVPActionsMenu = ({
  data,
  rsvpKey: currentRsvpKey,
  onRemoveAction,
  onRSVPAction,
  isRSVP,
}) => (
  <Dropdown
    overlay={
      <Menu className={styles.actionsMenu}>
        {isRSVP && currentRsvpKey != rsvpKey.YES && (
          <MenuItem>
            <Button
              onClick={() => onRSVPAction(data, rsvpCodes.YES)}
              type="link"
              block
              uppercase={false}
            >
              <MdCheckCircle className={styles.rsvpYesIcon} />{' '}
              <FormattedMessage id="shared.rsvpActionMenu.yes" />
            </Button>
          </MenuItem>
        )}
        {isRSVP && currentRsvpKey != rsvpKey.MAYBE && (
          <MenuItem>
            <Button
              onClick={() => onRSVPAction(data, rsvpCodes.MAYBE)}
              type="link"
              block
              uppercase={false}
            >
              <MdHelp className={styles.rsvpMaybeIcon} />
              <FormattedMessage id="shared.rsvpActionMenu.maybe" />
            </Button>
          </MenuItem>
        )}
        {isRSVP && currentRsvpKey != rsvpKey.NO && (
          <MenuItem>
            <Button
              onClick={() => onRSVPAction(data, rsvpCodes.NO)}
              type="link"
              block
              uppercase={false}
            >
              <MdCancel className={styles.rsvpNoIcon} />{' '}
              <FormattedMessage id="shared.rsvpActionMenu.no" />
            </Button>
          </MenuItem>
        )}
        <MenuItem>
          <Button
            onClick={() => onRemoveAction(data)}
            type="link"
            block
            uppercase={false}
          >
            <MdDeleteForever className={styles.rsvpRemoveIcon} />{' '}
            <FormattedMessage id="shared.rsvpActionMenu.remove" />
          </Button>
        </MenuItem>
      </Menu>
    }
    trigger={['click']}
    placement="bottomRight"
  >
    <span className={styles.moreIcon}>
      <MdMoreVert />
    </span>
  </Dropdown>
);

RSVPActionsMenu.propTypes = {
  data: PropTypes.object.isRequired,
  rsvpKey: PropTypes.string,
  onRemoveAction: PropTypes.func,
  onRSVPAction: PropTypes.func,
  isRSVP: PropTypes.bool,
};

RSVPActionsMenu.defaultProps = {
  data: [],
  onRemoveAction: () => {},
  onRSVPAction: () => {},
  isRSVP: true,
};

export default RSVPActionsMenu;
